import { useParams } from "@tanstack/react-router";
import { AnalyticsCatalogContext, catalogSeoQualityTier } from "@/components/analytics-catalog-context";
import { WorkContent } from "./$id/work-content";
type WorkSearch = {
  q?: string;
  format?: string;
  formatSet?: string[];
  sort?: string;
  country?: string;
  label?: string[];
  company?: string[];
  tag?: string[];
  year?: number[];
  filter?: ReleaseSearchFilter;
  tab?: (typeof VALID_TABS)[number];
  playing?: string;
  page?: number;
};
import { Route } from "/app/apps/web/src/routes/_app/work/$id.tsx";
function WorkRoute() {
  const {
    id
  } = useParams({
    from: "/_app/work/$id"
  });
  const loaderData = Route.useLoaderData();
  return <>
      <AnalyticsCatalogContext entityType="work" qualityTier={catalogSeoQualityTier(loaderData.work)} />
      <WorkContent id={id} />
    </>;
}
export { WorkRoute as component };